import { SequenceManagerAction } from "./SequenceManagerAction";
import { simswapCustomerDetailsApi, cemSimSwapSendOtp, cemSimSwapValidateOtp, cemSimSwapResendOtp } from "../api/api";

const CurrentNumberAction = {
  CURRENT_NUMBER_SELECTION: "CURRENT_NUMBER_SELECTION",
  GET_CUSTOMER_DETAILS_SUCCESS: "GET_CUSTOMER_DETAILS_SUCCESS",
  GET_CUSTOMER_DETAILS_FAILURE: "GET_CUSTOMER_DETAILS_FAILURE",
  SIMSWAP_CEM_OTP_INITIATE_SUCCESS: 'SIMSWAP_CEM_OTP_INITIATE_SUCCESS',
  SIMSWAP_CEM_OTP_VALIDATE_SUCCESS: 'SIMSWAP_CEM_OTP_VALIDATE_SUCCESS',
  SIMSWAP_CEM_OTP_RSEND_SUCCESS: 'SIMSWAP_CEM_OTP_RSEND_SUCCESS',
  UPDATE_FORM_DATA: 'UPDATE_FORM_DATA',
  IVR_CALL_BACK_STATUS_SUCCESS: 'IVR_CALL_BACK_STATUS_SUCCESS'
}

const win: any = window
const retryCount = win['AllowedAPIRetryCount'];
let customerCounter = 0;

const getCustomerDetails = (msisdn: any) => {
  return function (dispatch: any) {
    simswapCustomerDetailsApi(msisdn).then((response) => {
      console.log(response);
      dispatch({ type: CurrentNumberAction.GET_CUSTOMER_DETAILS_SUCCESS, payload: response });
    })
      .catch((error) => {
        //Display error
        if (error?.response?.status) {
          dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
        } else {
          ++customerCounter
          if (customerCounter < retryCount) {
            const url = error?.config?.url;
            const msisdn = url.split("?")[1].split('&')[0].split('=')[1];
            dispatch(getCustomerDetails(msisdn));
          } else {
            dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
          }
        }
      })
  }
}

const makeSelection = (phoneNumber: any, stepId: any, offerContainerId: any, getCustomerDetailsResponse: any, otpVal: any) => {
  return function (dispatch: any) {
    dispatch({ type: CurrentNumberAction.CURRENT_NUMBER_SELECTION, payload: { phoneNumber: phoneNumber, stepId: stepId, offerContainerId: offerContainerId, getCustomerDetailsResponse: getCustomerDetailsResponse, otpVal: otpVal} });
    dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['CurrentNumber'] });
  };
};


const cemSwapSendOtp = (number: any, idNumber: any, lang: any, emailVerification: boolean) => {
  return function (dispatch: any) {
    cemSimSwapSendOtp(number, idNumber, lang, emailVerification).then((response) => {
      dispatch({ type: CurrentNumberAction.SIMSWAP_CEM_OTP_INITIATE_SUCCESS, payload: response });
    })
      .catch((error) => {
        //Display error
        if (error?.response) {
          dispatch({ type: CurrentNumberAction.SIMSWAP_CEM_OTP_INITIATE_SUCCESS, payload: error.response });
        } else {
          dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
        }
      })
  }
}

const cemSwapValidateOtp = (otp: any, refId: any, clientId: any, ClientSecret: any) => {
  return function (dispatch: any) {
    cemSimSwapValidateOtp(otp, refId, clientId, ClientSecret)
      .then((response) => {
        dispatch({ type: CurrentNumberAction.SIMSWAP_CEM_OTP_VALIDATE_SUCCESS, payload: response });
      })
      .catch((err) => {
        //Display error
        const config = Object.assign(err?.config, { serviceName: 'validateLoginOTP' });
        const error = { ...err, config };

        if (error?.response) {
          dispatch({ type: CurrentNumberAction.SIMSWAP_CEM_OTP_VALIDATE_SUCCESS, payload: error?.response });
        } else {
          dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
        }
      })
  }
}

const cemSwapResendOtp = (refId: any, modes: any) => {
  return function (dispatch: any) {
    cemSimSwapResendOtp(refId, modes)
      .then((response) => {
        dispatch({ type: CurrentNumberAction.SIMSWAP_CEM_OTP_RSEND_SUCCESS, payload: response });
      })
      .catch((err) => {
        //Display error
        const config = Object.assign(err?.config, { serviceName: 'resendCEMOTP' });
        const error = { ...err, config };

        if (error?.response) {
          dispatch({ type: CurrentNumberAction.SIMSWAP_CEM_OTP_RSEND_SUCCESS, payload: error.response });
        } else {
          dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
        }
      })
  }
}

export { CurrentNumberAction, makeSelection, getCustomerDetails, cemSwapSendOtp, cemSwapValidateOtp, cemSwapResendOtp };